<template>
  <section class="content">
    <div class="inner">
      <div class="padded">
        <h1>My Basket</h1>
        <table class="basket" id="tblBasket">
          <thead>
            <tr>
              <td>Product</td>
              <td>Quantity</td>
              <td>Price</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(item, index) in basket.items">
              <td>
                <span class="name">{{ item.product.name }}</span>
                <!-- <span class="details">{{item.width}}x{{item.height}}mm {{item.wood_type}}{{item.treatment.name ? ', finished in ' + item.treatment.name + ' ' + item.treatment.option.name: ''}}</span> -->
                <span class="details" v-if="item._id">{{
              item.width
                ? "Height = " + item.height + "mm, Width = " + item.width + "mm,"
                : "Height = " +
                item.height +
                "mm, Width = " +
                item.left_width +
                "mm + " +
                item.right_width +
                "mm,"
            }}
                  {{ item.wood_type }}{{ item.hang ? ", " + item.hang + " Hang" : "" }}</span>
                <span class="details" v-if="item.product.detail">{{ item.product.detail }}</span>
                <span class="accessories">
                  <span :key="'post-' + index" v-for="(post, index) in item.posts">{{
              post.name + " (" + post.option.name + ")"
            }}</span>
                  <span :key="'iron-' + index" v-for="(iron, index) in item.ironmongery">{{
              iron.name + " (" + iron.option.name + ")"
            }}</span>
                  <span :key="'treatment-' + index" v-for="(treatment, index) in item.treatments">{{
              treatment.name + " (" + treatment.option.name + ")"
            }}</span>
                </span>
                <div class="notice"
                  v-if="item.product.price_type == 'Double' && item.product.category != IDs.threeQuarterID">
                  <div>
                    <i class="fa fa-info-circle"></i>
                    You will receive 2 x {{ Number(item.width / 2) }}mm wide gate leafs
                  </div>
                </div>
              </td>
              <td class="tdqty">
                <a class="qtylink">
                  <i @click.prevent="changeQty(index, item.qty - 1)" class="fa fa-minus"></i>
                </a>
                <input @change="changeQty(index, $event.target.value)" class="qty" type="text"
                  v-model.number="item.qty" />
                <a @click.prevent="changeQty(index, item.qty + 1)" class="qtylink">
                  <i class="fa fa-plus"></i>
                </a>
              </td>
              <td class="price">&pound;{{ item.price.toFixed(2) }}</td>
              <td class="edit">
                <page-link :href="item.product.url + '?edit=' + item._id + '#configure'" v-if="item._id">
                  <i class="fa fa-edit"></i> Edit
                </page-link>
              </td>
            </tr>
          </tbody>
        </table>
        <input type="button" class="continue" @click="$router.push('/#products')" value="Continue Shopping" />

        <input @click="emptyCart" class="empty" type="button" v-if="basket.items.length" value="Empty Cart" />

        <table class="totals">
          <tr>
            <td>Sub Total</td>
            <td>&pound;{{ subTotal.toFixed(2) }}</td>
          </tr>
          <tr>
            <td>
              <select v-model="delivery_type">
                <option value="Delivery">
                  Delivery
                </option>
                <option value="Collection">Collection</option>
              </select>
              <div class="del_col_desc" v-if="includesGates">
                <template v-if="delivery_type == 'Delivery'">{{ deliveryOptionText }}</template>
                <template v-if="delivery_type == 'Collection'">{{ collectionOptionText }}</template>
              </div>
            </td>
            <td>{{ delivery ? "&pound;" + delivery.toFixed(2) : misc ? misc.delivery_description : "" }}</td>
          </tr>
          <tr>
            <td>VAT @ 20%</td>
            <td>&pound;{{ vat.toFixed(2) }}</td>
          </tr>
          <tr v-if="delivery_discount">
            <td>Delivery discount</td>
            <td>-&pound;{{ delivery_discount.toFixed(2) }}</td>
          </tr>
          <tr v-if="collection_discount">
            <td>Collection discount</td>
            <td>-&pound;{{ collection_discount.toFixed(2) }}</td>
          </tr>
          <tr v-if="voucher_discount">
            <td>Voucher discount</td>
            <td>-&pound;{{ voucher_discount.toFixed(2) }}</td>
          </tr>
          <tr>
            <td>TOTAL inc VAT</td>
            <td id="totalOrderValue">&pound;{{ grandTotal.toFixed(2) }}</td>
          </tr>
        </table>

        <div class="lower">
          <textarea class="special" v-model="special_requirements"
            placeholder="Any special requirements about your order?"></textarea>

          <page-link :href="checkout_page.url" class="config-buy" v-if="grandTotal && checkout_page">
            <img alt="Proceed" src="../assets/ripple.svg" /> Proceed to checkout
          </page-link>

          <p class="delivery-note" v-if="misc && misc.lead_time">
            <i class="fa fa-truck"></i>
            {{ misc.lead_time }}
          </p>

          <div class="discount" v-if="subTotal > 0">
            <span class="error" v-if="voucher_error">{{ voucher_error }}</span>
            <span class="success" v-if="voucher_message">{{ voucher_message }}</span>

            <input class="txt-discount" placeholder="Voucher Code" type="text" v-model.trim="voucher_code" />
            <input @click="applyVoucher" class="btn-discount" type="button" value="Apply" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
  name: "Basket",
  data() {
    return { voucher_code: "", voucher_error: "", voucher_message: "" }
  },
  computed: {
    ...mapState(["basket", "misc", "checkout_page", "IDs"]),
    ...mapGetters({
      subTotal: "basket/subTotal",
      grandTotal: "basket/grandTotal",
      vat: "basket/vat",
      voucher_discount: "basket/voucher_discount",
      delivery_discount: "basket/delivery_discount",
      collection_discount: "basket/collection_discount",
      delivery: "basket/delivery",
      includesGates: "basket/includesGates"
    }),
    special_requirements: {
      set(val) {
        this.$store.commit("basket/special", val)
      },
      get() {
        return this.$store.state.basket.special_requirements
      }
    },
    delivery_type: {
      set(val) {
        this.$store.commit("basket/delivery_type", val)
      },
      get() {
        return this.$store.state.basket.delivery_type
      }
    },
    deliveryOptionText() {
      var val = "Delivery"

      if (!this.misc) return ""
      if (!this.misc.delivery_offer_enabled) return ""
      if (!this.misc.delivery_offer_text) return ""
      if (this.misc.delivery_offer_type == "Flat" && this.misc.delivery_offer_discount > this.delivery) return ""

      return this.misc.delivery_offer_text
    },
    collectionOptionText() {
      var val = "Collection"

      if (!this.misc) return ""
      if (!this.misc.collection_offer_enabled) return ""
      if (!this.misc.collection_offer_text) return ""
      if (this.misc.collection_offer_type == "Flat" && this.misc.collection_offer_discount > this.subTotal) return ""

      return this.misc.collection_offer_text
    }
  },
  methods: {
    changeQty(index, quantity) {
      this.$store.commit("basket/updateQty", { index, quantity })
    },
    emptyCart() {
      this.$store.commit("basket/emptyCart")
    },
    edit(item) {
      return item
    },
    applyVoucher() {
      this.voucher_error = ""
      this.voucher_message = ""

      var voucher = this.misc.vouchers.filter(v => v.code == this.voucher_code)

      if (!voucher.length) {
        this.voucher_error = "Invalid voucher code"
        return
      }

      if (this.basket.voucher && this.basket.voucher.code == this.voucher_code) {
        this.voucher_message = "Voucher already applied"
        return
      }

      if (voucher[0].type == "Fixed" && voucher[0].value >= this.subTotal) {
        this.voucher_error = "Add more items before applying this voucher"
        return
      }

      this.$store.commit("basket/applyVoucher", voucher[0])

      this.voucher_message = "Voucher applied"
      this.voucher_code = ""
    }
  }
}
</script>

<style scoped>
.tdqty {
  white-space: nowrap;
}

.lower {
  clear: both;
}

.config-buy {
  float: right;
}

.delivery-type {
  display: block;
  padding: 0 0.5rem;
  font-size: 1.8rem;
  cursor: pointer;
}

.delivery-note {
  display: inline-block;
}

.padded {
  padding: 3rem 0;
}

.basket {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  font-size: 1.5rem;
  margin-top: 2rem;
}

.basket td {
  padding: 1rem 2rem;
}

.basket thead td {
  color: #fff;
  font-size: 1.8rem;
}

.basket thead td {
  background-color: #434f50;
}

.totals {
  border-collapse: collapse;
  border: 0;
  float: right;
  margin-top: 2rem;
}

.del_col_desc {
  font-size: 1.3rem;
  max-width: 25rem;
  white-space: normal;
  line-height: 1.2;
}

.totals td {
  background-color: #f79227;
  padding: 0.5rem 2rem;
  white-space: nowrap;
  color: white;
  font-size: 1.8rem;
}

.basket tbody input {
  width: 3rem;
  border: 1px solid #eee;
  text-align: center;
  padding: 0.5rem;
}

.empty,
.continue {
  border: 0;
  padding: 1rem 2rem;
  width: auto;
  margin: 2rem;
  cursor: pointer;
}

.continue {
  background: #f79227;
  color: white;
  margin-right: 0;
}

.empty:hover {
  background: #cc0000;
  color: white;
}

.continue:hover {
  background: #434f50;
}

.basket thead td:first-child {
  width: 77.5%;
}

.basket span {
  display: block;
}

.basket .details {
  opacity: 0.7;
}

.basket .accessories {
  background: rgba(204, 204, 204, 0.116);
  padding: 1rem 2rem;
  display: inline-block;
  margin: 0.5rem 0;
  font-size: 1.3rem;
}

.basket tbody td {
  border-bottom: 1px solid #eee;
}

.qtylink {
  padding: 0 0.5rem;
  color: #434f50;
  cursor: pointer;
}

.edit {
  color: #434f50;
  font-size: 2rem;
}

.qtylink:hover {
  color: #f79227;
}

.notice>div {
  background: #f79227;
  color: white;
  font-size: 1.4rem;
  display: inline-block;
  padding: 0 1rem !important;
}

.discount {
  padding: 2rem;
}

.special {
  border: 1px solid #f79227;
  width: 50rem;
  max-width: 100%;
  height: 8rem;
  margin-left: 2rem;
  padding: 1rem;
  margin-top: 3rem;
}

.special::placeholder {
  color: #434f50;
}

.success,
.error {
  display: block;
  padding-bottom: 1rem;
  font-size: 1.5rem;
}

.txt-discount {
  border: 1px solid #eaecec;
  padding: 1rem;
}

.btn-discount {
  border: 0;
  padding: 1rem;
  border: 1px solid #eaecec;
  background: #eaecec;
  margin-left: 1rem;
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .config-buy {
    width: 100%;
  }

  .basket thead {
    display: none;
  }

  .basket {
    border-top: 5px solid #434f50;
  }

  .basket td {
    display: block;
    width: 100%;
    border-bottom: 0 !important;
  }

  .basket td:last-child {
    border-bottom: 1px solid #eee !important;
  }

  .totals {
    float: none;
    width: 100%;
  }

  .special {
    margin-left: 0;
    width: 100%;
  }
}
</style>
